import AboutUs from '@elem/compPage/about-us';
import { queryEditorDetailOnline } from 'lowcode/utils/service';
import * as Lowcomp from 'lowcomp/plugins/index-series/indexS';
import dynamic from 'next/dynamic';
import PageLayout from '@/components/PageLayout';
import SEOlinksA from '@/components/SEOlinksA';
import seoconfig from '@/seoconfig/aboutus';
import { useGlobal } from '@/utils/useGlobal';

import { isReadyLang, redirectTo404 } from '@/utils';
const PCLayout = dynamic(() => import('@/components/AboutUs'), { ssr: false });
const H5Layout = dynamic(() => import('@/componentsH5/AboutUs'), { ssr: false });

export default function Page({ SEO, id, data }: any) {
    const { isMobile, useRouter, useLang } = useGlobal();
    const { t } = useLang('aboutus');
    const LayoutCom = isMobile ? H5Layout : PCLayout;
    const { locale } = useRouter();

    return (
        <PageLayout theme="gray">
            <SEO title={t('seo_title')} description={t('seo_desc')} />
            <SEOlinksA locale={locale} list={seoconfig.include} pathname={seoconfig.url} />
            {locale === 'us' ? <AboutUs {...({ urlId: id, data, allTemp: Lowcomp } as any)} /> : <LayoutCom />}
        </PageLayout>
    );
}

export async function getServerSideProps(context: any) {
    const id: any = 'index';
    const locale: any = context.locale;
    if (locale !== 'en') {
        if (!isReadyLang(locale)) {
            return redirectTo404();
        }
    }
    let data = {
        thePage: {},
        theTemp: [],
        theData: {},
        theAttr: {},
        sqlData: {},
    };
    const homeData = null;
    // v2
    const isV2Flag = true;
    if (isV2Flag) {
        try {
            data = await queryEditorDetailOnline(id, locale);
        } catch (e) {
            console.log('e', e);
        }
    }

    // 首页换新弹窗时间线
    const START = new Date('2026/01/01 13:00:00 GMT+8').getTime();
    const END = new Date('2026/01/08 12:59:59 GMT+8').getTime();
    let now;
    try {
        const { _timer } = context.query;
        if (_timer) {
            now = new Date(_timer).getTime();
        } else {
            now = Date.now();
        }
    } catch (e) {
        now = Date.now();
    }
    const showTimeLine = now >= START && now <= END;
    // 首页换新弹窗是否关闭过
    const cookies = context.req.headers.cookie || '';
    const hasClosed = cookies.includes('new-home-theme-v3=true');

    return {
        props: {
            homeData: isV2Flag ? homeData || null : homeData || null,
            id,
            data,
            locale,
            showThemeChange: showTimeLine && !hasClosed && locale === 'us', //  在展示区间并且没有关闭过
        },
    };
}
